module.exports = __webpack_public_path__ + "static/media/s_6_bg.92a69cf1.mp4";